import { useEffect, useState } from "react";
import { Col, Row } from "antd";

import Sidebar from "./Sidebar";
import "../../assets/css/reputation-manager.css";
import Layout from "../../layout/Layout";

const ReputationManagerContainer = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setCollapsed(window.innerWidth <= 768); 
    };

    window.addEventListener("resize", handleResize);

    handleResize(); 

    return () => window.removeEventListener("resize", handleResize); 
  }, []);

  return (
    <Layout>
      <Row className="reputation-manager bg-f8f8f8 justify-content-between">
        <Col
          xs={collapsed ? 0 : 24}
          md={collapsed ? 0 : 6}
          lg={collapsed ? 0 : 4}
        >
          <Sidebar />
        </Col>
        <Col xs={24} md={collapsed ? 24 : 18} lg={collapsed ? 24 : 20}>
          <div className="rm-wrapper">
            <div className="rm-header">
              <div onClick={() => setCollapsed(!collapsed)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icon-tabler-layout-sidebar-left-collapse"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
                  <path d="M9 4v16" />
                  <path d="M15 10l-2 2l2 2" />
                </svg>
              </div>
            </div>
            <div className="rm-container">{children}</div>
          </div>
        </Col>
      </Row>
    </Layout>
  );
};

export default ReputationManagerContainer;
